import React from 'react';

import { IconProps } from './types';

const ShareIcon: React.FC<IconProps> = props => {
  const { width = '18', height = '18' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.09466 8.09632L7.44637 10.552L9.90126 16.9053C9.99129 17.1756 10.2391 17.3334 10.5319 17.3334C10.8022 17.3334 11.0499 17.1756 11.1626 16.9053L17.2891 1.58526C17.3791 1.33742 17.3342 1.04451 17.1313 0.864231C16.9511 0.683975 16.6582 0.616399 16.4105 0.706448L1.0943 6.83447C0.824221 6.94731 0.666626 7.19514 0.666626 7.46562C0.666626 7.75839 0.846873 8.00612 1.09466 8.09632ZM15.4423 2.55406L10.5547 14.8101L8.84288 10.3718L11.3206 7.89347C11.5908 7.62317 11.5908 7.1951 11.3206 6.94724C11.0503 6.67693 10.6224 6.67693 10.3746 6.94724L7.98694 9.29038L3.18937 7.44288L15.4423 2.55406Z"
        fill="#0276FE"
      />
    </svg>
  );
};

export default ShareIcon;
